import { useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';
import WhatsappService from '../service/whatsapp.service';

const STATUS_LABELS = {
  DISCONNECTED: 'Desconectado',
  CONNECTING: 'Conectando...',
  QR: 'Aguardando leitura do QR Code',
  CONNECTED: 'Conectado',
};

const STATUS_COLORS = {
  DISCONNECTED: 'danger',
  CONNECTING: 'warning',
  QR: 'warning',
  CONNECTED: 'success',
};

export const getWhatsappStatusLabel = (status) => STATUS_LABELS[status] || status;
export const getWhatsappStatusColor = (status) => STATUS_COLORS[status] || 'secondary';

export function useWhatsappSession(accountId) {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(false);
  const socketRef = useRef(null);

  const refresh = async () => {
    if (!accountId) return;
    setLoading(true);
    try {
      const status = await WhatsappService.getStatus(accountId);
      setSession(status);
    } catch (err) {
      console.error('Falha ao carregar status WhatsApp', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!accountId) return undefined;
    refresh();

    const apiBase =
      process.env.REACT_APP_API_BASE_URL ||
      process.env.REACT_API_BASE_URL ||
      'http://localhost:3001';
    const socketUrl = `${apiBase.replace(/\/$/, '')}/whatsapp`;
    const socket = io(socketUrl, {
      auth: { token: localStorage.getItem('token') },
      query: { accountId: String(accountId) },
      transports: ['websocket'],
      withCredentials: true,
    });
    socketRef.current = socket;

    socket.on('connect', () => {
      socket.emit('join', { accountId: Number(accountId) });
    });

    socket.on('whatsapp.session.updated', (state) => {
      if (!state) return;
      setSession(state);
    });

    return () => {
      socket.off('whatsapp.session.updated');
      socket.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountId]);

  return { session, loading, refresh, setSession };
}
